import { render, staticRenderFns } from "./HospitalAnnouncementDetail.vue?vue&type=template&id=56ce3770"
import script from "./HospitalAnnouncementDetail.vue?vue&type=script&lang=ts"
export * from "./HospitalAnnouncementDetail.vue?vue&type=script&lang=ts"
import style0 from "./HospitalAnnouncementDetail.vue?vue&type=style&index=0&id=56ce3770&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports